import { useState } from 'react';
import Avatar from '@material-ui/core/Avatar';
import clsx from 'clsx';
import Tooltip from 'components/UI/Tooltip';
import MembersDialog from 'components/UI/Dialogs/MembersDialog';
import styles from './index.module.scss';
import getMemberDisplayName from 'src/utils/getMemberDisplayName';
type Avatar = {
  email: string;
  displayName: string | null;
  fullName: string | null;
  thumbnail: string | null;
};
const AvatarsFilter = ({
  maxItems = 7,
  items,
  onChange,
}: {
  items: Avatar[];
  maxItems?: number;
  onChange: (string) => void;
}) => {
  const avatarItems = [...items];
  const dialogItems = avatarItems.splice(maxItems);
  const defaultSelectedItemsObj = avatarItems.reduce((acc, item) => {
    acc[item.email] = false;
    return acc;
  }, {});
  const [selectedTeammatesFromAvatar, setSelectedTeammatesFromAvatar] =
    useState(defaultSelectedItemsObj);
  const [selectedTeammatesFromDialog, setSelectedTeammatesFromDialog] = useState([]);
  const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  const handleCloseDialog = () => {
    setAnchorEl(null);
  };
  const handleOpenDialog = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleSelect = (email: string) => {
    const filteredMembersMap = {
      ...selectedTeammatesFromAvatar,
      [email]: !selectedTeammatesFromAvatar[email],
    };
    const filteredMembersArr = [];
    for (const key in filteredMembersMap) {
      filteredMembersMap[key] && filteredMembersArr.push(key);
    }
    setSelectedTeammatesFromAvatar(filteredMembersMap);
    onChange([...selectedTeammatesFromDialog, ...filteredMembersArr]);
  };
  const handleChangeDialog = ({ type, email }) => {
    const newSelectedMembers =
      type === 'add'
        ? [...selectedTeammatesFromDialog, email]
        : selectedTeammatesFromDialog.filter((teammate) => teammate !== email);
    setSelectedTeammatesFromDialog(newSelectedMembers);
    onChange([...newSelectedMembers, ...Object.keys(selectedTeammatesFromAvatar)]);
  };
  return (
    <div className={styles.wrapper}>
      {avatarItems.map((member) => {
        const name = getMemberDisplayName(member);

        return (
          <Tooltip key={member.email} title={name} placement={'bottom'}>
            <button
              onClick={() => handleSelect(member.email)}
              className={clsx({
                [styles.avatar]: true,
                [styles.selectedAvatar]: selectedTeammatesFromAvatar[member.email],
              })}
            >
              <Avatar
                className={styles.avatarImage}
                key={member.email}
                alt={name}
                src={member.thumbnail}
              >
                {name?.[0] || member.email?.[0]}
              </Avatar>
            </button>
          </Tooltip>
        );
      })}
      {dialogItems.length ? (
        <>
          <button className={styles.dialogButton} onClick={handleOpenDialog}>
            +{dialogItems.length}
          </button>
          <MembersDialog
            members={dialogItems}
            selected={selectedTeammatesFromDialog}
            onClose={handleCloseDialog}
            anchorEl={anchorEl}
            onChange={handleChangeDialog}
          />
        </>
      ) : (
        <></>
      )}
    </div>
  );
};
export default AvatarsFilter;
